<div class="modal-header">
  <div class="d-flex align-items-center">
    <h4 class="modal-title" id="modal-basic-title">
      Duplica {{ title }} per esercizio
    </h4>
  </div>
  <ideapa-icon-button
    icon="close"
    cssClasses="text-primary hover-bg-primary"
    (clicked)="cancel()"
    >
  </ideapa-icon-button>
</div>
<form [formGroup]="form" (submit)="onSubmit(form)">
  <div class="modal-body">
    <div class="row">
      <div class="col-6 ideapa-form-field">
        <ideapa-numeric-field
          formControlName="fromEsercizio"
          [label]="'Da esercizio'"
          [showGroupSeparator]="false"
          [readOnly]="true"
          [errors]="form.controls['fromEsercizio'].errors || {} | ngrxFormsErr"
          [shouldShowError]="
            form.dirty && form.controls['fromEsercizio'].invalid
          "
          >
        </ideapa-numeric-field>
      </div>
      <div class="col-6 ideapa-form-field">
        <ideapa-numeric-field
          formControlName="toEsercizio"
          [label]="'A esercizio'"
          [showGroupSeparator]="false"
          [errors]="form.controls['toEsercizio'].errors || {} | ngrxFormsErr"
          [shouldShowError]="form.dirty && form.controls['toEsercizio'].invalid"
          >
        </ideapa-numeric-field>
      </div>
    </div>
    <div class="row">
      @if (result) {
        <div class="mt-3">
          <div class="import-result">{{ result.message }}</div>
          <div class="mt-2">
            @if (hasFile()) {
              <ideapa-button
                [cssClasses]="'btn-outline-primary'"
                [text]="'Scarica log'"
                [icon]="'download'"
                (clicked)="onDownloadLog()"
              ></ideapa-button>
            }
          </div>
        </div>
      }
    </div>
  </div>
  <div class="modal-footer">
    <ideapa-button
      class="me-2"
      [cssClasses]="'btn-outline-primary'"
      [text]="'Chiudi'"
      (clicked)="cancel()"
    ></ideapa-button>

    <ideapa-button
      type="submit"
      [cssClasses]="'btn-primary'"
      [text]="'Duplica'"
    ></ideapa-button>
  </div>
</form>
